import React, { useState } from "react";
import MonthFilterSelect from "../../../../Component/DigitalMarketing/MonthFilter";
import { useGetLeadsServiceTypeQuery, useGetTopConsultantsQuery } from "../../../../Service/dashboard";
import allConsultant from "../../../../assets/DigitalMarketing/image/allconsultant.svg";
import Consultant from "../../../../assets/DigitalMarketing/image/consultant.svg";

const ConsultantSummary = (data: any) => {
  const [selectedServiceType, setSelectedServiceType] = useState("this Month");

  const monthOptions = [
    { value: "this Month", label: "This Month" },
    { value: "previous Month", label: "Previous Month" },
  ];

  const allConsultantsData = {
    id: "0",
    name: "All Consultants",
    count: data?.data?.data?.totalRevenue || 0,
    bgcolor: true, // Explicitly set as true for the first data
  };

  const consultantList = data?.data?.data?.appointmnetRevenue?.map((consultant, index) => ({
    id: consultant.id,
    name: consultant.consultantName,
    speciality: consultant.speciality,
    count: consultant.totalRevenue,
  }));

  const allData = [allConsultantsData, ...(consultantList || [])];

  return (
    < div style={{height:"80vh",overflowY:"auto"}}>
      <div className="d-flex justify-content-between">
        <div>
          <span className="dashboard-heading mb-4">Consultant Summary</span>
        </div>
      </div>
      <div className="row p-1 align-items-center">
        {allData.map((d,i) => (
          <div key={i} className="col-12">
            <div
              className="cards mt-2 d-flex justify-content-between align-items-center"
              style={{
                minHeight: "65px",
                backgroundColor: d.bgcolor ? "#E1D9F7" : "#FFF",
              }}
            >
              <div className="d-flex gap-3 align-items-center">
                <div>
                  <img src={d.bgcolor ? allConsultant : Consultant} alt="Consultant" />
                </div>
                <div>
                  {d.bgcolor ? (
                    <span className="f-32 fw-600">{d.name}</span>
                  ) : (
                    <div className="d-flex flex-column gap-1">
                      <span className="f-18 fw-400">{d.name}</span>
                      <span className="f-16 text-muted">{d.speciality}</span>
                    </div>
                  )}
                </div>
              </div>
              <div className="f-18 fw-500">{d.count}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConsultantSummary;
